<div class="relative flex min-w-dropdown" #overlayOrigin>
    <input
        #input
        type="text"
        apxInput
        autocomplete="off"
        size="full"
        [formControl]="inputControl"
        [readOnly]="!enableSearch"
        [id]="inputId"
        (keydown)="handleKeyDown($event)"
        (focus)="menuOpen = true" />

    @if (enableSearch ? enableSearch && !menuOpen : true) {
    <! -- Arrow down icon -->
    <span
        porIcon
        class="absolute right-[16px] top-[calc(50%-8px)] pointer-events-none"
        [ngClass]="{
            'opacity-50': disabled
        }"
        icon="caretdown"
        [width]="16"
        [height]="16"></span>
    }

    @if (enableSearch) {
    <! -- Search Icon -->
    <span
        porIcon
        class="absolute right-[16px] top-[calc(50%-8px)] pointer-events-none transition-opacity opacity-0"
        [ngClass]="{
            'opacity-100': enableSearch && menuOpen
        }"
        icon="magnifier"
        [width]="16"
        [height]="16"></span>
    }

        @if (!disableClear && currentOption) {
            <! -- Clear selection button -->
            <button class="absolute right-[40px] top-[calc(50%-8px)]" type="button" apx-button [disabled]="disabled" [id]="closeBtnId" (click)="clearSelection()">
                Clear
            </button>
        }
</div>

<ng-template apxOverlay position="below" [show]="menuOpen" [origin]="overlayOrigin">
    <div
        apxOverlayClose
        (closeComponent)="menuOpen = false"
        [isComponentOpen]="menuOpen"
        [additionalElementIds]="[inputId, closeBtnId]"
        [style.width.px]="overlayWidth"
        class="border-solid border-input border-input-border-default">
        @if (displayOptions.length) {
        <cdk-virtual-scroll-viewport orientation="vertical" [itemSize]="itemSize" [style.min-height.px]="itemSize" [style.height.px]="scrollViewportHeight">
            <apx-dropdown-item
                *cdkVirtualFor="let option of displayOptions; let idx = index"
                [value]="option.value"
                [label]="option.label"
                [isFocused]="currentlyActiveIndex === idx"
                [isSelected]="currentValue === option.value"
                (itemClicked)="selectItem($event)"></apx-dropdown-item>
        </cdk-virtual-scroll-viewport>
        } @else {
        <div [style.height.px]="itemSize" class="flex items-center justify-center font-roboto text-input bg-dropdown-item-background-default">
            <span>{{ noResultsLabel }}</span>
        </div>
        }
    </div>
</ng-template>
